export default {
  methods: {
    prepare(findChip) {
      return {
        ...(findChip || {
          color: '#EEEEEE',
          textColor: '#9E9E9E',
        }),
        label: findChip && findChip.label ? findChip.label : (this.value || 'Erro'),
      };
    },
    formatContent(arr = []) {
      return arr.map((item) => ({
        ...item,
        label: item.text,
      }));
    },
  },
};
